/** Skeleton3D property formatter: the bone count and `show_rest_only`, ahead of the shared Node3D sections. */
import { formatNode3DProperties } from '../../base/node3d/propertyFormatter';
export function formatSkeleton3DProperties(properties) {
    return [
        {
            title: 'Skeleton3D',
            items: [
                { label: 'Bones', value: properties.bones.length.toString() },
                { label: 'Show Rest Only', value: properties.showRestOnly.toString() },
            ],
        },
        ...formatNode3DProperties(properties),
    ];
}
//# sourceMappingURL=propertyFormatter.js.map